export default __webpack_public_path__ + "static/media/minus-sign.0bd07a29.svg";